import { combineReducers } from 'redux';

import optional from './optional';
import required from './required';

const textFields = combineReducers({
  optional,
  required,
});

export default textFields;
